import { Component, OnInit, Output, EventEmitter, OnChanges, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { AppInsightsService } from '../../services/app-insights.service';

@Component({
  selector: 'app-informed-consent-form-signature',
  templateUrl: './informed-consent-form-signature.component.html',
  styleUrls: ['./informed-consent-form-signature.component.scss']
})
export class InformedConsentFormSignatureComponent implements OnInit, OnChanges {
  consentFormSignature: FormGroup;
  @Output() hasValidSignature = new EventEmitter<boolean>();
  @Output() hasValidEmail = new EventEmitter<boolean>();
  @Output() data = new EventEmitter();
  @Input('email') email: string;
  today: string;

  constructor(
    private _formBuilder: FormBuilder,
    private appInsights: AppInsightsService
  ) {
    const todayDate = new Date();
    const month = (todayDate.getMonth() + 1).toString().padStart(2, '0');
    const day = todayDate.getDate().toString().padStart(2, '0');
    const year = todayDate.getFullYear();
    this.today = `${month}/${day}/${year}`;
  }

  ngOnInit(): void {
    this.consentFormSignature = this._formBuilder.group({
      AdditionalInfo1: [''],
      AdditionalInfo2: [''],
      AdditionalInfo3: [''],
      AdditionalInfo4: [''],
      Initial: ['', [Validators.maxLength(5), Validators.pattern('^[a-zA-Z]+$')]],
      PrintName: ['', [Validators.required]],
      DateSign: { disabled: true, value: null },
      email: ['', [Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'), Validators.required]],
      Signature: [''],
    });

    // Monitor form status changes for validity
    this.consentFormSignature.statusChanges.subscribe(() => {
      this.checkAndEmitValidity();
    });

    const printNameControl = this.consentFormSignature.get('PrintName');

    // Immediate signature sync and validation
    printNameControl.valueChanges.subscribe(value => {
      if (value !== null) {
        const trimmedValue = value.trim();
        this.consentFormSignature.get('Signature').setValue(trimmedValue, { emitEvent: false });
        this.checkAndEmitValidity();
      }
    });

    // Debounced data emission only
    printNameControl.valueChanges
      .pipe(debounceTime(700))
      .subscribe(value => {
        if (value !== null) {
          const trimmedValue = value.trim();
          if (trimmedValue) {
            const formData = { 
              ...this.consentFormSignature.getRawValue(), 
              PrintName: trimmedValue,
              Signature: trimmedValue,
              DateSign: this.today 
            };
            this.data.emit(formData);
          }
        }
      });

    // Initial validity check
    this.checkAndEmitValidity();
  }

  private checkAndEmitValidity() {
    const printNameControl = this.consentFormSignature.get('PrintName');
    const initialControl = this.consentFormSignature.get('Initial');
    const printNameValue = printNameControl.value.trim() || '';

    const isValid = !printNameControl.invalid &&
      !initialControl.invalid &&
      printNameValue !== '';

    this.hasValidSignature.emit(isValid);
    this.hasValidEmail.emit(!this.consentFormSignature.get('email').invalid);
  }

  ngOnChanges(): void {
    if (this.email != null) {
      this.consentFormSignature.get('email').setValue(this.email);
    }
  }
}
